import { useAppSelector } from '@/store/hooks';
import { Link, styled } from '@mui/material';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useMemo } from 'react';

const InfoLink = styled(Link)({
  fontWeight: 700,
});

const Copyright = ({ className }) => {
  const copyrightClassname = classNames(className, 'text-[#6C7278] text-center');
  const { whitelabel } = useAppSelector(state => state.currentWhitelabel);

  const copyrightText = useMemo(() => {
    return `© ${new Date().getFullYear()} ${whitelabel?.whitelabelName || 'Ribeye'}. All rights reserved.`;
  }, [whitelabel]);

  return (
    <div className={copyrightClassname}>
      <span className='pr-[6px]'>{copyrightText}</span>
      <InfoLink underline='hover' href='#'>
        Terms & Conditions
      </InfoLink>
      <span className='px-[15px]'>|</span>
      <InfoLink underline='hover' href='#'>
        Privacy & Policy
      </InfoLink>
    </div>
  );
};

Copyright.propTypes = {
  className: PropTypes.string,
};

export default Copyright;
